<script>
import { commands } from '../../js/lib/functions.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { renderIdCard, renderCert, renderRSOCert, renderIdCardBack } from '../../js/utils/renderer.js'
import { showConfirm } from '../../js/utils/confirm.js'
import { rsoLevelToLevel } from '../../../functions/domain/certification-utils.js';
import { PageShowError } from '@trullock/page-manager'
import { getLevelName } from '../../../functions/domain/map/map.js';
import { autoMapFromFirestore } from '@trullock/firebase-common'

export const pageName = 'admin-user-fulfill-id-card';
export const pageRoute = '/admin/user/{userId}/fulfillment/{orderId}';
export const title = 'UKRA ID Card Fulfillment'
export const requireAuth = false;
export const requireAdmin = false;
export const requireEmailVerified = false;

export default {
	data() {
		return { 
			user: null,
			fulfillment: null,
			idCard: null,
			idCardBack: null,
			l1Cert: null,
			l2Cert: null,
			l3Cert: null,
			rsoCert: null,
			ready: false
		}
	},
	methods: {
		rsoLevelToLevel,
		getLevelName,
		async boot(opts) {
			try
			{
				let data = autoMapFromFirestore(await (await fetch('/api/fulfillment?orderId=' + opts.orderId)).json())

				this.user = data.user;
				this.fulfillment = data.order;
				
					
				this.idCard = await renderIdCard(this.user);
				this.idCardBack = await renderIdCardBack(this.user);
				
				if(this.user.certification.level1.status == 'passed')
					this.l1Cert = await renderCert(this.user, 'level1');

				if(this.user.certification.level2.status == 'passed')
					this.l2Cert = await renderCert(this.user, 'level2');

				if(this.user.certification.level3.status == 'passed')
					this.l3Cert = await renderCert(this.user, 'level3');
					
				if(this.user.rso.status == 'passed')
					this.rsoCert = await renderRSOCert(this.user);
				

				
				this.ready = true;
			}
			catch(e)
			{
				if(e.toString().indexOf('not found (null)') > -1)
					throw new PageShowError('/admin', 'User not found', {}, 'replace');

				throw e;
			}
		},
		
		async dispatch() {

			showConfirm({
				title: 'Confirm dispatch',
				message: 'Mark order as dispatched? This cannot be un-done.',
				dismissable: false,
				buttons: [
					{
						'text': 'Cancel',
					},
					{
						text: 'Dispatch',
						style: 'primary',
						action: async () => {
							
							this.isDirty = false;

							showLoading();

							let result = await commands.users.payment.dispatchMembershipCard({
								userId: this.fulfillment.userId,
								orderId: this.fulfillment.id
							})

							window.location.reload()
						}
					}
				]
			})
			
			
		}
	}
}
</script>
<template>
<div class="container py-5" v-if="ready">
    <form ref="form" @submit.prevent="submit">
		<div class="row justify-content-center">
			<div class="col col-lg-8">
				<div class="card">
					<div class="card-header">
						<h4 v-if="fulfillment.type == 'card_lanyard'" class="card-header-title">Membership Card with Lanyard and Holder</h4>
						<h4 v-else-if="fulfillment.type == 'card'" class="card-header-title">Membership Card only</h4>
					</div>
					<div class="card-body">
						<h1>Front</h1>
						<a :download="`id-card-${user.id}.png`" :href="idCard" target="_blank"><img :src="idCard" style="max-width: 100%" /></a>
						<h1 class="my-5">Back</h1>
						<a :download="`id-card-back-${user.id}.png`" :href="idCardBack" target="_blank"><img :src="idCardBack" style="max-width: 100%" /></a>
						<h1 class="my-5">Lanyard and Holder</h1>
						<h4 v-if="fulfillment.type == 'card_lanyard'" class="text-success">Include <span class="fe fe-check"></span></h4>
						<h4 v-else-if="fulfillment.type == 'card'" class="text-danger">Exclude <span class="fe fe-x"></span></h4>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Fulfillment</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<address class="selectable">
									{{ fulfillment.shippingDetails.name }}<br />
									{{ fulfillment.shippingDetails.line1 }},<br />
									{{ fulfillment.shippingDetails.line2 }},<br />
									{{ fulfillment.shippingDetails.city }},<br />
									{{ fulfillment.shippingDetails.postcode }}<br />
									{{ fulfillment.shippingDetails.country }}
								</address>
							</div>
							<div class="col">
								<p>Status: {{  fulfillment.status == 'ready' ? 'Ready' : 'Dispatched' }}</p>
								<button class="btn btn-primary" :disabled="fulfillment.status != 'ready'" @click="dispatch">Mark as Dispatched <span class="fe fe-box"></span></button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="false" class="col col-lg-4">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">HPR Certificates</h4>
					</div>
					<div class="card-body">
						<div v-if="user.certification.level1.status == 'passed'">
							<a :download="`level-1-cert-${user.id}.png`" :href="l1Cert" target="_blank"><img :src="l1Cert" style="max-width: 100%" /></a>
						</div>
						<div v-if="user.certification.level2.status == 'passed'">
							<a :download="`level-2-cert-${user.id}.png`" :href="l2Cert" target="_blank"><img :src="l2Cert" style="max-width: 100%" /></a>
						</div>
						<div v-if="user.certification.level3.status == 'passed'">
							<a :download="`level-3-cert-${user.id}.png`" :href="l3Cert" target="_blank"><img :src="l3Cert" style="max-width: 100%" /></a>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">RSO</h4>
					</div>
					<div class="card-body">
						<div v-if="user.rso.status == 'passed'">
							<a :download="`rso-cert-${user.id}.png`" :href="rsoCert" target="_blank"><img :src="rsoCert" style="max-width: 100%" /></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
</template>